import { Box } from "@mui/material";
import { FieldsetHTMLAttributes, type ReactNode } from "react";

export default function Fieldset({
  children,
  ...props
}: { children: ReactNode } & FieldsetHTMLAttributes<HTMLFieldSetElement>) {
  return (
    <Box component="fieldset" {...props} sx={{ border: 0, p: 0, m: 0 }}>
      {children}
    </Box>
  );
}
